const GET_SPLASH_SCREEN_INIT = '@splash-screen/GET_SPLASH_SCREEN_INIT';
const GET_SPLASH_SCREEN_SUCCESS = '@splash-screen/GET_SPLASH_SCREEN_SUCCESS';
const GET_SPLASH_SCREEN_FAILURE = '@splash-screen/GET_SPLASH_SCREEN_FAILURE';

export { GET_SPLASH_SCREEN_INIT, GET_SPLASH_SCREEN_SUCCESS, GET_SPLASH_SCREEN_FAILURE };
